var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBovedillaEps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 994.92 431.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:53.42px;fill:#27365d;font-family:Roboto-Regular, Roboto;}.cls-2,.cls-5{fill:none;}.cls-2{stroke:#00acec;}.cls-2,.cls-4,.cls-5,.cls-6{stroke-miterlimit:10;stroke-width:4px;}.cls-3{fill:#00acec;}.cls-4{fill:#f7f7f7;}.cls-4,.cls-5,.cls-6{stroke:#169ed7;}.cls-6{fill:#d6d6d6;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bovedilla-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dibujo"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(386.23 416.67)"
  }, "ancho"), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(926.03 189.41)"
  }, "luz"), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 956.96,
    y1: 6.19,
    x2: 956.96,
    y2: 127.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 943.96,
    y: 4.19,
    width: 26,
    height: 4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 956.96,
    y1: 341.41,
    x2: 956.96,
    y2: 220.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 943.96,
    y: 339.41,
    width: 26,
    height: 4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4,
    y1: 403.32,
    x2: 376.85,
    y2: 403.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2,
    y: 390.32,
    width: 4,
    height: 26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 914.85,
    y1: 403.32,
    x2: 579.63,
    y2: 403.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 912.85,
    y: 390.32,
    width: 4,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2,
    y: 13.8,
    width: 914.85,
    height: 320
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2,
    y1: 173.8,
    x2: 916.85,
    y2: 173.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 2,
    y: 2,
    width: 14.85,
    height: 343.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 92,
    y: 2,
    width: 14.85,
    height: 343.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 182,
    y: 2,
    width: 14.85,
    height: 343.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 272,
    y: 2,
    width: 14.85,
    height: 343.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 362,
    y: 2,
    width: 14.85,
    height: 343.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 452,
    y: 2,
    width: 14.85,
    height: 343.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 542,
    y: 2,
    width: 14.85,
    height: 343.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 632,
    y: 2,
    width: 14.85,
    height: 343.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 722,
    y: 2,
    width: 14.85,
    height: 343.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 812,
    y: 2,
    width: 14.85,
    height: 343.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 902,
    y: 2,
    width: 14.85,
    height: 343.61
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBovedillaEps);
export default __webpack_public_path__ + "static/media/bovedilla-EPS.d97ae3f9b19ee122fdf3c8026f1d713f.svg";
export { ForwardRef as ReactComponent };